import React from "react";

import isIntuit from "Intuit/isIntuit";
import { connect } from "react-redux";
import isSquare from "Square/isSquare";

import { StandaloneTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { CardHeader, CardSection } from "Common/Card";
import { Row, Col } from "Common/Grid";
import Header from "Cobalt/Header";
import { Table } from "Common/Table";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

import { requestInformation, requestDeleteInformation } from "./api";

import makeBem from "Utils/makeBem";

const bem = makeBem("UserSettings");

const branding = isSquare() ? "square" : isIntuit() ? "intuit" : "default";

type Props = {
  email: string;
  name: string;
  requestInformation: () => void;
  requestDeleteInformation: () => void;
};

export const UserSettingsDumb = ({ email, name, requestInformation, requestDeleteInformation }: Props) => (
  <div>
    <ResponsiveTopBar branding={branding} />
    <Col sm={10} smOffset={1}>
      <CardHeader>User Information</CardHeader>
      <CardSection>
        <Row>
          <Col sm={12}>
            <Table>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{name}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{email}</td>
                </tr>
                <tr>
                  <td />
                  <td />
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </CardSection>
      <CardHeader>Manage your data</CardHeader>
      <CardSection>
        <BodyText>
          {isIntuit() && (
            <BodyText>
              SimplyInsured only has access to information that was provided from Intuit or from you. We are dedicated to making sure your data stays protected.
              Your privacy and the security of your personal data are, and always will be, our highest priority.
            </BodyText>
          )}

          {isSquare() && (
            <BodyText>
              SimplyInsured only has access to information that was provided from Square or from you. We are dedicated to making sure your data stays protected.
              Your privacy and the security of your personal data are, and always will be, our highest priority.
            </BodyText>
          )}

          {!isIntuit() && !isSquare() && (
            <BodyText>
              SimplyInsured only has access to information that you voluntarily provide to us. We are dedicated to making sure your data stays protected. Your
              privacy and the security of your personal data are, and always will be, our highest priority.
            </BodyText>
          )}
        </BodyText>
        <Row className={bem("privacyRow")}>
          <Col sm={4} smOffset={1} className={bem("privacyBlock")}>
            <Header level={7} className={bem("privacyHeader")}>
              Download your data
            </Header>
            <p>
              If you would like to recieve a consolidated copy of your personal information, please request it by clicking on the button below. We will get back
              to you with the data you requested in a timely manner.
            </p>
            <StandaloneTrigger
              trigger={(props) => (
                <Button {...props} round className={bem("privacyButton")}>
                  Request Data
                </Button>
              )}
              runOnOpen={requestInformation}
              modal={(props) => (
                <Modal {...props}>
                  <ModalHeader closeButton>Information Requested</ModalHeader>
                  <ModalBody>We have received your request. We will send an email with your information in 14 days.</ModalBody>
                  <ModalFooter>
                    <Button color="white" onClick={props.onHide}>
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              )}
            />
          </Col>
          <Col sm={4} smOffset={2} className={bem("privacyBlock")}>
            <Header level={7} className={bem("privacyHeader")}>
              Delete User Information
            </Header>
            <p>
              SimplyInsured is dedicated to making sure that your data stays protected. If you still want to remove your data from our system, please click on
              the button below. We will process your request in a timely manner.
            </p>
            <StandaloneTrigger
              trigger={(props) => (
                <Button {...props} round className={bem("privacyButton")}>
                  Delete Information
                </Button>
              )}
              runOnOpen={requestDeleteInformation}
              modal={(props) => (
                <Modal {...props}>
                  <ModalHeader closeButton>Request to Delete Information</ModalHeader>
                  <ModalBody>We have received your request. We will send an email confirming that your data has been removed in 14 days.</ModalBody>
                  <ModalFooter>
                    <Button color="white" onClick={props.onHide}>
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              )}
            />
          </Col>
        </Row>
      </CardSection>
    </Col>
  </div>
);

const mapStateToProps = (state) => ({
  email: state.accountSetting.email || "Undefined",
  name: state.accountSetting.name || "Undefined",
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  requestInformation: () => {
    dispatch(requestInformation());
  },
  requestDeleteInformation: () => {
    dispatch(requestDeleteInformation());
  },
});

const UserSettings = connect(mapStateToProps, mapDispatchToProps)(UserSettingsDumb);

export default UserSettings;
